"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const fmko_ts_common_1 = require("fmko-ts-common");
const LabeledInputFieldWidget_1 = tslib_1.__importDefault(require("../widget/LabeledInputFieldWidget"));
// Component rendered in the user interface
// <div style="display: flex; flex-direction: column">
//   <label for="input-id">
//   <input id="input-id" type="text" [readOnly]>
// </div>
class WCAGNumberField extends LabeledInputFieldWidget_1.default {
    constructor(args) {
        super({ ...args, inputType: "text" });
        const { allowDecimals = false, allowNegative = false, decimalsRequired = false, numberOfDecimals = 2 } = args;
        this.allowDecimals = allowDecimals;
        this.allowNegative = allowNegative;
        this.decimalsRequired = decimalsRequired;
        this.numberOfDecimals = numberOfDecimals;
    }
    setNumberFieldProperties(args) {
        const { allowDecimals, allowNegative, decimalsRequired, numberOfDecimals } = args;
        this.allowDecimals = allowDecimals ?? this.allowDecimals;
        this.allowNegative = allowNegative ?? this.allowNegative;
        this.decimalsRequired = decimalsRequired ?? this.decimalsRequired;
        this.numberOfDecimals = numberOfDecimals ?? this.numberOfDecimals;
    }
    decorateLabeledInputFieldWidgetElement(args) {
        this.element = document.createElement("div");
        this.element.classList.add("number-field");
        if (this.allowDecimals) {
            this.fieldElement.inputMode = "decimal";
        }
        else {
            this.fieldElement.inputMode = "numeric";
        }
        this.add(this.labelElement);
        this.add(this.fieldElement);
        this.add(this.hintElement);
    }
    parseFieldElementValue(inputValue) {
        if (!inputValue || inputValue.length === 0) {
            return undefined;
        }
        let parsed;
        inputValue = inputValue.split(".").join("");
        if (this.allowDecimals) {
            const commaConverted = inputValue.replace(",", ".");
            parsed = fmko_ts_common_1.NumberUtil.parseFloatWithPrecision(commaConverted, this.numberOfDecimals);
        }
        else {
            parsed = parseInt(inputValue, 10);
        }
        if (isNaN(parsed)) {
            return undefined;
        }
        return parsed;
    }
    setFieldElementValue(value) {
        // Update field value
        if (value === null || value === undefined) {
            this.fieldElement.value = "";
        }
        else if (this.allowDecimals) {
            this.fieldElement.value = (new fmko_ts_common_1.DecimalFormatter(this.numberOfDecimals, !this.decimalsRequired)).format(value);
        }
        else {
            this.fieldElement.value = WCAGNumberField.integerFormat.format(value);
        }
    }
    isValidNextChar(currentValue, char, selectionStart = null, selectionEnd = null) {
        if (currentValue != null) {
            const isEntireValueSelected = selectionStart !== undefined
                && currentValue.substr(selectionStart, selectionEnd) !== currentValue;
            if (isEntireValueSelected && currentValue.substring(selectionStart).startsWith("-")) {
                return false;
            }
        }
        if (char >= "0" && char <= "9") {
            return true;
        }
        if (this.allowDecimals && char === ",") {
            if (!currentValue || !currentValue.includes(",")) {
                return true;
            }
        }
        if (this.allowNegative && char === "-") {
            if (!currentValue) {
                return true;
            }
            if (!currentValue.startsWith("-")) {
                const prefix = currentValue.substring(0, selectionEnd).trim();
                if (prefix.length === 0) {
                    return true;
                }
            }
        }
        return false;
    }
}
WCAGNumberField.integerFormat = new fmko_ts_common_1.IntegerFormatter();
exports.default = WCAGNumberField;
//# sourceMappingURL=WCAGNumberField.js.map